const deserializeMessage = require('./deserializeMessage.js');

module.exports = function unboxFromRumorMessage(rumorMessage) {
  const message = deserializeMessage(rumorMessage.data);
  message.transactionId = rumorMessage.transactionId;
  message.fromAddress = rumorMessage.headers['X-TB-FROM-ADDRESS'];

  return message;
};
